import * as React from 'react';
import { Link } from 'react-router-dom';

import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right';

export default ({ item }) =>
  item.to ? (
    <>
      <Link to={item.to} style={{ color: '#39579e', textDecoration: 'none' }}>
        {item.label}
      </Link>
      <span style={{ display: 'inline-block', width: 20 }} />
      <Arrow />
      <span style={{ display: 'inline-block', width: 20 }} />
    </>
  ) : (
    <span>{item.label}</span>
  );



// WEBPACK FOOTER //
// ./src/components/sidebar/Breadcrumb.tsx